import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { ApplicantSF6Api } from "../../../shared/nestjs/gd-integrated/services/applicant-sf6.api";
import { ResponseListingVacancy, ResponseSaveDto } from "../../../shared/nestjs/gd-integrated/dto/applicant.dto";

@Injectable()
export class ApplicantBloc {

  constructor(
    public applicantSF6Api: ApplicantSF6Api
  ) {
  }

  listingVacancy(payload, page, limit): Observable<ResponseListingVacancy> {
		return this.applicantSF6Api.listingVacancy(payload, page, limit);
  }

  listingApplicant(payload, page, limit): Observable<ResponseListingVacancy> {
		return this.applicantSF6Api.listingApplicant(payload, page, limit);
  }

  appAction(requestNo, apphistoryCode, applicantId): Observable<any> {
		return this.applicantSF6Api.appAction(requestNo, apphistoryCode, applicantId);
  }

  nextPIC(appStatus, apphistoryCode, applicantId): Observable<any> {
		return this.applicantSF6Api.nextPIC(appStatus, apphistoryCode, applicantId);
  }
  
  empListVacancy(requestNo, catCode, stepFixed): Observable<any> {
		return this.applicantSF6Api.empListVacancy(requestNo, catCode, stepFixed);
  }

  recruitmentDetail(requestNo): Observable<any> {
		return this.applicantSF6Api.recruitmentDetail(requestNo);
  }

  jobApplication(apphistoryCode, applicantId): Observable<any> {
		return this.applicantSF6Api.jobApplication(apphistoryCode, applicantId);
  }

  preScreening(requestNo, apphistoryCode, applicantId): Observable<any> {
		return this.applicantSF6Api.preScreening(requestNo, apphistoryCode, applicantId);
  }

  selProgress(requestNo, apphistoryCode, applicantId): Observable<any> {
		return this.applicantSF6Api.selProgress(requestNo, apphistoryCode, applicantId);
  }

  appPersonal(applicantId): Observable<any> {
		return this.applicantSF6Api.appPersonal(applicantId);
  }

  saveAction(data): Observable<ResponseSaveDto> {
		return this.applicantSF6Api.saveAction(data);
	}

  mainInfo(apphistoryCode, applicantId): Observable<any> {
		return this.applicantSF6Api.mainInfo(apphistoryCode, applicantId);
  }

  saveJobApp(data): Observable<ResponseSaveDto> {
		return this.applicantSF6Api.saveJobApp(data);
	}

  saveSelProgress(data): Observable<ResponseSaveDto> {
		return this.applicantSF6Api.saveSelProgress(data);
	}

  mediaSource(): Observable<any> {
		return this.applicantSF6Api.mediaSource();
  }

  vacancyDetail(requestNo): Observable<any> {
    return this.applicantSF6Api.vacancyDetail(requestNo);
  }
  
  otherPIC(limit, skip, search): Observable<any> {
		return this.applicantSF6Api.otherPIC(limit, skip, search);
  }

  appContact(applicantId): Observable<any> {
		return this.applicantSF6Api.appContact(applicantId);
  }

  appAddress(applicantId): Observable<any> {
		return this.applicantSF6Api.appAddress(applicantId);
  }

  appEmergency(applicantId): Observable<any> {
		return this.applicantSF6Api.appEmergency(applicantId);
  }

  appEducation(applicantId): Observable<any> {
		return this.applicantSF6Api.appEducation(applicantId);
  }

  appExperience(applicantId): Observable<any> {
		return this.applicantSF6Api.appExperience(applicantId);
  }

  appFamily(applicantId): Observable<any> {
		return this.applicantSF6Api.appFamily(applicantId);
  }

  savePersonal(data): Observable<any> {
    return this.applicantSF6Api.savePersonal(data);
  }

  saveContact(data): Observable<any> {
    return this.applicantSF6Api.saveContact(data);
  }

  saveAddress(data): Observable<any> {
    return this.applicantSF6Api.saveAddress(data);
  }

  saveEmergency(data): Observable<any> {
    return this.applicantSF6Api.saveEmergency(data);
  }

  saveEducation(data): Observable<any> {
    return this.applicantSF6Api.saveEducation(data);
  }

  saveExperience(data): Observable<any> {
    return this.applicantSF6Api.saveExperience(data);
  }

  saveFamily(data): Observable<any> {
    return this.applicantSF6Api.saveFamily(data);
  }

  addAddress(data): Observable<any> {
    return this.applicantSF6Api.addAddress(data);
  }

  addEmergency(data): Observable<any> {
    return this.applicantSF6Api.addEmergency(data);
  }

  addEducation(data): Observable<any> {
    return this.applicantSF6Api.addEducation(data);
  }

  addExperience(data): Observable<any> {
    return this.applicantSF6Api.addExperience(data);
  }

  addFamily(data): Observable<any> {
    return this.applicantSF6Api.addFamily(data);
  }

  deleteAddress(data): Observable<any> {
    return this.applicantSF6Api.deleteAddress(data);
  }

  deleteEmergency(data): Observable<any> {
    return this.applicantSF6Api.deleteEmergency(data);
  }

  deleteEducation(data): Observable<any> {
    return this.applicantSF6Api.deleteEducation(data);
  }

  deleteExperience(data): Observable<any> {
    return this.applicantSF6Api.deleteExperience(data);
  }

  deleteFamily(data): Observable<any> {
    return this.applicantSF6Api.deleteFamily(data);
  }

  deletePersonal(data): Observable<any> {
    return this.applicantSF6Api.deletePersonal(data);
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/recruitment/applicant.bloc.ts